import { Button } from '~/components/ui/button';

interface AssistantEmptyMessageProps {
  /** Retry handler — re-asks the same question. Omitted → no button rendered. */
  onRetry?: (() => void) | undefined;
}

/**
 * Subtle placeholder for a Q&A turn that completed with no content (the agent
 * returned an empty `message_complete`). Muted styling — not the red error
 * card — plus a Retry that re-asks the question, so the user never faces a
 * silent blank bubble.
 */
export function AssistantEmptyMessage({ onRetry }: AssistantEmptyMessageProps) {
  return (
    // role=status politely announces the empty result without interrupting.
    <div role="status" className="bg-muted/40 space-y-2 rounded-xl p-3">
      <p className="text-muted-foreground text-xs leading-5">Lily didn&apos;t return a response.</p>
      {onRetry ? (
        <Button
          type="button"
          variant="outline"
          size="sm"
          className="h-7 cursor-pointer text-xs"
          onClick={onRetry}
        >
          Retry
        </Button>
      ) : null}
    </div>
  );
}
